import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function setupBannerScrollTrigger() {
  const trigger = document.getElementById('js-banner-trigger');
  const header = document.querySelector('.l-header__wrap');
  const items = document.querySelectorAll('.js-banner-items');
  const windowH = window.innerHeight;
  let startValue, endValue, scrub, y, scrollableHeight;
  const listTrigger = document.querySelector('.p-banner__list--trigger');

  if (window.innerWidth <= 1024) { // 画面幅が768px以下（モバイル）
    scrollableHeight = (windowH - header.clientHeight) * 2;
    startValue = `bottom bottom-=64`;
    endValue = `+=${scrollableHeight} bottom`;
    listTrigger.style.height = 100;
    y = 0;
  } else { // デスクトップ
    scrollableHeight = (windowH - header.clientHeight) * 3;
    startValue = `top top+=${header.clientHeight}`;
    endValue = `+=${scrollableHeight} bottom`;
    y = 0;
  }

  if (trigger) {
    ScrollTrigger.create({
      pin: true,
      trigger: trigger,
      start: startValue,
      end: endValue,
      // markers: true
    })
  }

  const itemsTrigger = document.querySelectorAll('.p-banner__items--trigger');

  itemsTrigger.forEach((item, index) => {
    let inner = items[index];
    ScrollTrigger.create({
      trigger: item,
      start: `top top+=${header.clientHeight}`,
      end: `bottom top+=${header.clientHeight}`,
      onEnter: () => gsap.to(inner, { y: y, duration: .3 }), // innerImg をフェードイン
      onLeave: () => {
        // if (index !== 0) {
        //   gsap.to(inner, { y: '100%', duration: .3, opacity: 0 })
        // }
      }, // innerImg をフェードアウト
      // onEnterBack: () => gsap.to(inner, { y: 0, duration: .3, opacity: 1 }), // スクロールバックでフェードイン
      onLeaveBack: () => {
        if (index !== 0) {
          gsap.to(inner, { y: '100%', duration: .3 })
        }
      }, // スクロールバックでフェードアウト
      // markers: true,
    })
  })
}

if (window.innerWidth <= 1024) { // 画面幅が768px以下（モバイル）
} else {
  // 初回ロード時にScrollTriggerを設定
  setupBannerScrollTrigger();

  // ウィンドウリサイズ時にScrollTriggerをリフレッシュ
  window.addEventListener('resize', () => {
    // 再計算のためにScrollTriggerをクリア
    ScrollTrigger.refresh();

    // 必要なら再度ScrollTriggerを設定するために関数を呼び出す
    setupBannerScrollTrigger();
  });
}
